import React, { Component } from "react";
import { Circle, Group, Rect } from "react-konva";
import { connect } from "react-redux";
import { ManifoldStructureType } from "../../lib/manifolds";

class ManifoldStructures extends Component{
  state = this.getInitialState();

  get height() {
    return ( this.props.chamberHeight * this.assembly.length ) +
      ( ( this.assembly.length - 1 ) * this.props.rowSpacing );
  }

  get halfStructureSize() {
    return this.structureSize / 2;
  }

  get structureSize() {
    try {
      let part = this.props.manifold.assembly.find(part => part.rowIndex === this.props.manifold.letRow);

      let nyloplastStructureSize, concreteStructureSize;
      nyloplastStructureSize = this.props.manifold.manifoldSize.nyloplastStructureSize;
      concreteStructureSize = this.props.manifold.manifoldSize.concreteStructureSize;

      if (!nyloplastStructureSize) {
        nyloplastStructureSize = 30;
      }
      if (!concreteStructureSize) {
        concreteStructureSize = 48;
      }
      switch (part.structureType) {
        case ManifoldStructureType.Nyloplast: //Nylo
          return this.props.getScaledValue(nyloplastStructureSize / 12);
        default:  //Concrete
          return this.props.getScaledValue(concreteStructureSize / 12);
      }
    } catch (exception) {
      console.error(`manifold-structures.js structureSize() :: ${exception.message}`);
      return 0;
    }
  }

  get trunkSeparation() {
    const trunkSep = this.props.manifold.getTrunkSeparation(
      this.props.chamberRows[this.props.manifold.letRow],
      this.props.chamberRows,
      this.props.manifoldSeparations,
      false,
      this.props.stoneBedSeparationDistance) || 0;
    return this.props.getScaledValue(trunkSep);
  }

  get width() {
    return this.trunkSeparation;
  }

  get x() {
    return this.props.x - this.width;
  }

  get y() {
    return this.props.y;
  }

  getOverlappedManifoldHighlight() {
    return {
      showManifoldConflict: true,
      basingLineThickness: 0.5,
      structureRoundStrokeColor: "darkred",
      structureSquareStrokeColor: "darkred",
      structureNyloplastStrokeColor: "darkred",
      structureRoundFillColor: "orange",
      structureSquareFillColor: "orange",
      structureNyloplastFillColor: "orange",
      pipeLineStrokeWidth: 0.8,
      pipeLineColor: "red",
      reset: true,
      isOverlap: true,
      isMainManifold: false
    };
  }

  getCurrentManifoldHighlight() {
    return {
      showManifoldConflict: false,
      basingLineThickness: 0.1,
      structureRoundStrokeColor: "DarkRed",
      structureSquareStrokeColor: "DarkRed",
      structureNyloplastStrokeColor: "DarkRed",
      structureRoundFillColor: "Yellow",
      structureSquareFillColor: "Yellow",
      structureNyloplastFillColor: "Yellow",
      pipeLineStrokeWidth: 0.5,
      pipeLineColor: "#0078D4",
      reset: false,
      isOverlap: false,
      isMainManifold: true
    };
  }

  getInitialState() {
    return {
      showManifoldConflict: false,
      basingLineThickness: 0.1,
      structureRoundStrokeColor: "red",
      structureSquareStrokeColor: "red",
      structureNyloplastStrokeColor: "blue",
      structureRoundFillColor: "white",
      structureSquareFillColor: "white",
      structureNyloplastFillColor: "lightblue",
      pipeLineStrokeWidth: 0.5,
      pipeLineColor: "green",
      reset: false,
      isOverlap: false,
      isMainManifold: false
    };
  }

  resetState() {
    this.setState({ ...this.getInitialState() });
  }


  showOverlapHighlight() {
    if (
      this.props.overlappingManifold
      && this.props.isOverlapPresent
    ) {
      this.setState(this.getOverlappedManifoldHighlight());
    } else if (
      this.state.reset
      && !this.props.isOverlapPresent
    ) {
      if (this.state["isMain"]) {
        this.setState(this.getCurrentManifoldHighlight());
      } else {
        if (!this.props.isOverlapPresent) {
          this.resetState();
        }
      }
    }
  }

  showCurrentManifoldHighlight() {
    if (this.props.currentManifold && this.props.currentManifold._id === this.props.manifold._id) {
      if (!this.state.isOverlap) {
        this.setState(this.getCurrentManifoldHighlight());
      }
      this.showOverlapHighlight();
    } else {
      this.resetState();
    }
  }

  getManifoldStructureTypes = () => {
    const lessHalfStructureSize = this.halfStructureSize - 0.1 * this.halfStructureSize;
    const lessTwiceHalfStructureSize = this.halfStructureSize - 0.2 * this.halfStructureSize;

    const perimeter = this.props.getScaledValue(1); // 12 inches
    const halfPerimeter = this.props.getScaledValue(0.55); // 12 inches

    // debugCollisions
    const forceDebug = false;
    let debug = false; //Allows to visualize structure collisions (forced) - use for debug
    if (this.props.oppositeStructureCollisionDetected) {
      debug = true; //Do not change
    }

    const
      ManifoldStructureRound = () => (
        <Group x={this.halfStructureSize} y={this.props.chamberHeight / 2}>

          {( this.props.oppositeManifoldsIds.some(id => {
            return id === this.props.manifold._id;
          }) ) ? <Circle radius={this.halfStructureSize + perimeter}
                         stroke={"rgba(247, 64, 40, 0.3)"}
                         fill={"rgba(247, 64, 40, 0.3)"}
                         strokeWidth={0}
                         visible={debug} />
            : null}

          {forceDebug ? <Circle radius={this.halfStructureSize + perimeter}
                                stroke={"rgba(247, 64, 40, 0.3)"}
                                fill={"rgba(247, 64, 40, 0.3)"}
                                strokeWidth={0}
                                visible={forceDebug} />
            : null}

          <Circle radius={this.halfStructureSize}
                  stroke={this.state.structureRoundStrokeColor}
                  fill={this.state.structureRoundFillColor}
                  strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />
          <Circle radius={lessHalfStructureSize}
                  stroke={this.state.structureRoundStrokeColor}
                  fill={this.state.structureRoundFillColor}
                  strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />
        </Group>
      ),
      ManifoldStructureSquare = () => (
        <Group x={0} y={this.props.chamberHeight / 2 - this.halfStructureSize}>


          {( this.props.oppositeManifoldsIds.some(id => {
            return id === this.props.manifold._id;
          }) ) ? <Rect x={-halfPerimeter}
                       y={-halfPerimeter}
                       stroke={"rgba(247, 64, 40, 0.3)"}
                       fill={"rgba(247, 64, 40, 0.3)"}
                       width={this.structureSize + perimeter}
                       height={this.structureSize + perimeter}
                       strokeWidth={0}
                       visible={debug} />
            : null}

          {forceDebug ? <Rect x={-halfPerimeter}
                              y={-halfPerimeter}
                              stroke={"rgba(247, 64, 40, 0.3)"}
                              fill={"rgba(247, 64, 40, 0.3)"}
                              width={this.structureSize + perimeter}
                              height={this.structureSize + perimeter}
                              strokeWidth={0}
                              visible={forceDebug} />
            : null}

          <Rect stroke={this.state.structureSquareStrokeColor}
                fill={this.state.structureSquareFillColor}
                width={this.structureSize}
                height={this.structureSize}
                strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />
          <Rect x={lessHalfStructureSize - lessTwiceHalfStructureSize}
                y={lessHalfStructureSize - lessTwiceHalfStructureSize}
                stroke={this.state.structureSquareStrokeColor}
                fill={this.state.structureSquareFillColor}
                width={lessHalfStructureSize * 2}
                height={lessHalfStructureSize * 2}
                strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />


        </Group>
      ),
      ManifoldStructureNyloplast = () => (
        <Group x={this.halfStructureSize} y={this.props.chamberHeight / 2}>

          {( this.props.oppositeManifoldsIds.some(id => {
            return id === this.props.manifold._id;
          }) ) ? <Circle radius={this.halfStructureSize + perimeter}
                         stroke={"rgba(247, 64, 40, 0.3)"}
                         fill={"rgba(247, 64, 40, 0.3)"}
                         strokeWidth={0}
                         visible={debug} />
            : null}


          {forceDebug ? <Circle radius={this.halfStructureSize + perimeter}
                                stroke={"rgba(247, 64, 40, 0.3)"}
                                fill={"rgba(247, 64, 40, 0.3)"}
                                strokeWidth={0}
                                visible={forceDebug} />
            : null}

          <Circle radius={this.halfStructureSize}
                  stroke={this.state.structureNyloplastStrokeColor}
                  fill={this.state.structureNyloplastFillColor}
                  strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />
          <Circle radius={lessHalfStructureSize}
                  stroke={this.state.structureNyloplastStrokeColor}
                  fill={this.state.structureNyloplastFillColor}
                  strokeWidth={this.props.getScaledValue(this.state.basingLineThickness)} />
        </Group>
      );

    return {
      ManifoldStructureRound: () => <ManifoldStructureRound />,
      ManifoldStructureSquare: () => <ManifoldStructureSquare />,
      ManifoldStructureNyloplast: () => <ManifoldStructureNyloplast />
    };
  };

  getOffsetX() {
    return 0;
  }

  getOffsetY( row ) {
    return row * this.props.chamberHeight + ( row * this.props.rowSpacing );
  }

  componentDidUpdate( prevProps ) {
    if (this.props.manifoldEntry !== prevProps.manifoldEntry) {
      this.showCurrentManifoldHighlight();
    }
  }

  render() {
    const {
      ManifoldStructureRound,
      ManifoldStructureSquare,
      ManifoldStructureNyloplast
    } = this.getManifoldStructureTypes();
    return this.props.manifold
      .assembly
      .map(( part, key ) => {
        let
          x = this.getOffsetX(key),
          y = this.getOffsetY(key),
          groupProps = { x, y, key };

        switch (part.structureType) {
          case ManifoldStructureType.Round:
            return (
              <Group {...groupProps}>

                <ManifoldStructureRound />

              </Group> );
          case ManifoldStructureType.Square:
            return (
              <Group {...groupProps}>
                <ManifoldStructureSquare />
              </Group> );
          case ManifoldStructureType.Nyloplast:
            return (
              <Group {...groupProps}>
                <ManifoldStructureNyloplast />
              </Group> );
          default:
            return null;
        }
      });
  }
}

export default connect(
)(ManifoldStructures);



// WEBPACK FOOTER //
// ./src/components/Drawings/manifold-structures.js